import { get, IHttpRequestConfig, withCachedBuffer } from "@/browser";
import { extractDataFromResponse } from "@/core/api";
import { compose, IURLSearchParams } from "@/core/url";

import { codelistTypeArray, ICodelist, TCodelistName } from "./types";

const API = {
  get: "/api/public/codelists/{codelistName}",
};

export interface IFetchCodelistParams extends IURLSearchParams {
  codelistName: TCodelistName;
}

const composeUrl = ({ codelistName }: IFetchCodelistParams) => {
  return compose(API.get, { codelistName });
};

export const fetchCodelist = <T = ICodelist>(params: IFetchCodelistParams, options?: IHttpRequestConfig) => {
  const url = composeUrl(params);
  return withCachedBuffer(
    async () => get<T[]>(url, options).then(extractDataFromResponse).then(codelistTypeArray),
    url,
  );
};
